import Link from "next/link";
import type { ReactNode } from "react";
import React from "react";
import { useOptionalUser } from "@/components/env/EnvContext.js";
import { Permission } from "@rosette/ts/src/business/role/Permission.js";
import { Role } from "@rosette/ts/src/business/role/Role.js";
import { cn } from "@rosette/ts/src/util/cn.js";
import { motion } from "framer-motion";
import { Card } from "@rosette/web_components/src/ui/Card.js";


interface AdBannerProps {
    className?: string;
}


export function AdBanner({ className }: AdBannerProps) {
    const user = useOptionalUser();
    const roles = (user ? Role.list(user) : []);

    let adContent: ReactNode | null = null;
    if (!user) {
        adContent = (
            <p className="m-0">
                Want to save your games and make your progress count?
                {" "}
                <Link href="/register">
                    Register for an account here!
                </Link>
            </p>
        );
    } else if (!Permission.NO_ADS.hasPermission(roles)) {
        adContent = (
            <p className="m-0">
                Become an awesome play-ur
                {" "}
                <Link href="/premium">
                    with RoyalUr Gold and Diamond.
                </Link>
            </p>
        );
    }
    if (!adContent)
        return (<></>);

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
                ease: "easeInOut" as const,
                duration: 0.75,
                delay: 1.5,
            }}>

            <Card className={cn(
                "flex items-center justify-center p-4 md:p-4",
                className ?? null,
            )}>
                <div className="flex-1 text-base">
                    {adContent}
                </div>
            </Card>
        </motion.div>
    );
}
